export default __webpack_public_path__ + "static/media/loading_eSefaz.68da7f03.gif";